/* eslint-disable import/no-cycle */
import { NestApiType, nestCall } from '@/composables/nestApi';
import { UserState, Logout } from '@/composables/User';
import { getV4DashboardUrl } from '@/composables/shopVersion';

const POLL_INTERVAL_MS = 30 * 1000;

let intervalId: ReturnType<typeof setInterval> | null = null;
let inFlight = false;
let handlingLogout = false;

async function pollOnce(): Promise<void> {
  if (inFlight || handlingLogout) return;

  // Skip polling when not authenticated, no active shop, or mid shop-switch
  const state: any = UserState as any;
  if (!state?.isAuthenticated) return;
  if (!state?.activeShop) return;
  if (state?.changingShop) return;

  const idShop = state.activeShop?.idShop
    ?? state.activeShop?.id_shop
    ?? state.activeShop?.id;
  if (!idShop) return;

  inFlight = true;
  try {
    const res: any = await nestCall(
      'post',
      NestApiType.DEFAULT,
      '/shop/verify-platform-version',
      {},
      '',
      { idShop, assumedVersion: 'v5' },
    );

    if (!res) return;
    if (res.error) return;

    const forceLogout = res.forceLogout === true;
    const notV5 = res.shopVersion && res.shopVersion !== 'v5';

    if (forceLogout || notV5) {
      handlingLogout = true;
      stopShopVersionPoller();
      try {
        await Logout();
      } finally {
        window.location.href = getV4DashboardUrl();
      }
    }
  } catch {
    // silent — will retry next tick
  } finally {
    inFlight = false;
  }
}

export function startShopVersionPoller(): void {
  if (intervalId !== null) return;
  intervalId = setInterval(() => {
    pollOnce();
  }, POLL_INTERVAL_MS);
}

export function stopShopVersionPoller(): void {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
